import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

import TabStrip from '../shared/TabStrip';

import { accountPath } from './accountRelatedModel';
import { useAccountOfferId } from './useAccountOfferId';

type AccountTab = 'related' | 'history';

const ACCOUNT_TABS: Array<{ label: string; value: AccountTab }> = [
  { label: 'Related', value: 'related' },
  { label: 'Account History', value: 'history' },
];

const ACCOUNT_TAB_PATH_SUFFIX: Record<AccountTab, string> = {
  related: '',
  history: '/history',
};

interface Props {
  accountId: string;
  activeTab: AccountTab;
}

export default function AccountTabs({ accountId, activeTab }: Props) {
  const navigate = useNavigate();
  const offerId = useAccountOfferId();

  return (
    <Box sx={{ mb: 3 }}>
      <TabStrip
        activeTab={activeTab}
        counts={{}}
        onTabChange={(tab) => navigate(accountPath(accountId, offerId, ACCOUNT_TAB_PATH_SUFFIX[tab]))}
        tabs={ACCOUNT_TABS}
      />
    </Box>
  );
}
